<template>
  <hm-container>
    <div slot="header" class="flex flex-between">
      <el-radio-group
        v-model="queryType"
        @change="switchQueryType"
        size="small"
      >
        <el-radio-button label="user">用户标签</el-radio-button>
        <el-radio-button label="goods">商品标签</el-radio-button>
      </el-radio-group>
      <div>
        <el-input
          size="small"
          class="mr10"
          type="text"
          v-model="keyword"
          :placeholder="'请输入' + (queryType === 'user' ? '用户名/手机号' : '商品名')"
        ></el-input>
        <el-button
          :disabled="!keyword"
          size="small"
          type="primary"
          @click="search"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table mb20" v-if="isInit">
      <el-table
        stripe
        border
        ref="multipleTable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        max-height="400"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          v-if="queryType === 'user'"
          key="id"
          prop="id"
          label="用户ID"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          v-if="queryType === 'user'"
          key="memberName"
          prop="memberName"
          show-overflow-tooltip
          label="用户昵称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            key="storeName"
            show-overflow-tooltip
            label="商户名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          v-if="queryType === 'user'"
          key="mobile"
          prop="mobile"
          label="用户手机号"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          v-if="queryType === 'goods'"
          key="id"
          prop="id"
          label="商品ID"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          v-if="queryType === 'goods'"
          key="spuName"
          prop="spuName"
          label="商品名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          v-if="queryType === 'goods'"
          key="wxshopPrice"
          label="商品价格"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            ￥{{ scope.row.wxshopPrice }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template v-slot="scope">
            <el-button
              @click="viewDetails(scope.row)"
              size="small"
              type="text"
              class="blue"
              >画像详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="empty-img" v-else>
      <img
        src="https://imgcdn.hemiao100.com/tag/SketchPngcc9cd871e482d9ca11d9f763a3b5f45dd3f8fe9e87ee563b683ce8c1c6af1e0c.png"
        alt=""
      />
    </div>
    <div class="hm-pagination" v-if="isInit">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-container>
</template>

<script>
export default {
  data() {
    return {
      isInit: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: "",
      keyword: "",
      queryType: "user",
    };
  },
  created() {},
  mounted() {},
  methods: {
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    switchQueryType() {
      this.list = [];
      this.total = 0;
      this.keyword = "";
    },
    async queryList() {
      const { result } = await this.$store.dispatch(
        "queryTagIncludeResultList",
        {
          tagType: this.queryType,
          queryName: this.keyword,
        }
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
      this.isInit = true;
      console.log(this.list);
    },
    viewDetails(row) {
      this.$router.push({
        name: "PortraitDetails",
        query: {
          centerId: row.centerId,
          goodId: row.goodId,
          queryType: this.queryType,
        },
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryActivityList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryActivityList();
    },
  },
};
</script>

<style scoped lang="scss"></style>
